var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0b75c2",
    d: "M11.94 2.71 9.53 8.32H7.12c-.4 0-.79.03-1.17.11l1-2.4.04-.09.06-.16c.03-.07.05-.13.08-.18 1.16-2.69 2.46-3.53 4.81-2.89"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0b75c2",
    d: "M16.88 7.82h-5.5l1.789-4.16 2.187.92.003.001c1.199.498 1.966.987 2.419 1.528.084.113.15.206.216.313L18 6.43c.072.113.115.204.137.288l.01.039.016.036c.033.073.049.12.059.165l.004.016.004.017c.085.287.118.611.089.978a7 7 0 0 0-1.439-.15z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0b75c2",
    d: "M12.52 18.16h.25c.3 0 .55-.27.55-.6 0-.42-.12-.48-.38-.58l-.42-.15z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#0b75c2",
    d: "M18.29 10.02c-.45-.13-.92-.2-1.41-.2H7.12q-1.02 0-1.92.39a4.89 4.89 0 0 0-2.96 4.49v1.95c0 .24.02.47.05.71.22 3.18 1.92 4.88 5.1 5.09.23.03.46.05.71.05h7.8c3.7 0 5.65-1.76 5.84-5.26.01-.19.02-.39.02-.59V14.7a4.9 4.9 0 0 0-3.47-4.68M13.28 16c.46.16 1.08.5 1.08 1.56 0 .91-.71 1.64-1.59 1.64h-.25v.22c0 .29-.23.52-.52.52s-.52-.23-.52-.52v-.22h-.09c-.96 0-1.75-.81-1.75-1.81 0-.29.23-.52.52-.52s.52.23.52.52c0 .42.32.77.71.77h.09v-1.69l-.76-.27c-.46-.16-1.08-.5-1.08-1.56 0-.91.71-1.64 1.59-1.64h.25v-.22c0-.29.23-.52.52-.52s.52.23.52.52V13h.09c.96 0 1.75.81 1.75 1.81 0 .29-.23.52-.52.52s-.52-.23-.52-.52c0-.42-.32-.77-.71-.77h-.09v1.69z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#0b75c2",
    d: "M10.68 14.64c0 .42.12.48.38.58l.42.15v-1.33h-.25c-.31 0-.55.27-.55.6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.146bbe8fa077b5a33ad445fef0093b71.svg";
export { ForwardRef as ReactComponent };